export default __webpack_public_path__ + "static/media/it-for-me-img.be5ada25.svg";